import axios, { AxiosHeaders } from "axios";
import store from "@src/_store/store";

const instance = axios.create();

instance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Interceptor to check release version
instance.interceptors.response.use(
    function (response) {
        const headerKey = "x-tips4y-release";
        const headerResponse = response.headers;

        if (
            headerResponse &&
            headerResponse instanceof AxiosHeaders &&
            headerResponse.has(headerKey)
        ) {
            const responseRelease = headerResponse[headerKey].toLowerCase();
            const currentReleaseVersion = (
                store.getters["domain/getReleaseVersion"] || ""
            ).toLowerCase();

            if (currentReleaseVersion !== responseRelease) {
                store.commit(
                    "domain/setReleaseVersion",
                    headerResponse[headerKey]
                );
            }
        }

        return response;
    },
    function (error) {
        console.error("Response error:", error);
        return Promise.reject(error);
    }
);

window.axios = instance;